import { Button, Col, Input, Row } from "reactstrap";
import styles from "./AddNewCoupon.module.scss";
import { useState } from "react";
import SelectProductsModal from "../SelectProductsModal/SelectProductsModal";
import Multiselect from "../../../../../components/common/MultiselectDropdown/Multiselect";
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper";

const AddNewCoupon = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <h5>Add New Coupon</h5>

      <SelectProductsModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />

      <div>
        <YellowHeaderWrapper title="General Information">
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Coupon Code:</Col>
            <Col lg="5" xxl="4">
              <Input placeholder="Enter name of the product" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Coupon type:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Select Discounts"
                options={[
                  "Percentage off",
                  "Delivery discount",
                  "Buy 1 get 1 free",
                ]}
              />
            </Col>
          </Row>
        </YellowHeaderWrapper>
      </div>

      <div>
        <YellowHeaderWrapper title="Details">
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Validity Period:</Col>
            <Col lg="6" xxl="5">
              <Row className="g-0">
                <Col lg="5">
                  <Input type="date" />
                </Col>
                <Col lg="2" className="d-flex justify-content-center align-items-center fw-bold">
                  -
                </Col>
                <Col lg="5">
                  <Input type="date" />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Display Area:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Choose from dropdown"
                options={["Store page", "Product detail page"]}
              />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Discount:</Col>
            <Col lg="5" xxl="4">
              <Input placeholder="Choose from dropdown" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Total Coupons:</Col>
            <Col lg="5" xxl="4">
              <Input placeholder="Choose from dropdown" />
            </Col>
          </Row>
        </YellowHeaderWrapper>
      </div>

      <div>
        <YellowHeaderWrapper title="Conditions">
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Minimum Purchase Value:</Col>
            <Col lg="5" xxl="4">
              <Input placeholder="Enter name of the product" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Maximum Uses:</Col>
            <Col lg="5" xxl="4">
              <Input placeholder="Choose from dropdown" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Apply to:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Choose from dropdown"
                options={[
                  "Whole Store",
                  "Specific products",
                  "Specific categories",
                ]}
              />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Target Groups:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Choose from dropdown"
                options={["New customers", "Frequent buyers"]}
              />
            </Col>
          </Row>
        </YellowHeaderWrapper>
      </div>

      <div className="d-flex justify-content-center">
        <div className={styles.addProductBtnContainer}>
          <button className={styles["add-product-btn"]}>Cancel</button>

          <Button
            type="button"
            color="primary"
            className={styles.productBtn}
            onClick={() => { }}
          >
            Add Coupon
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddNewCoupon;